import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Categeory_1 from '../../../assets/images/home_page_3/category/01.png'
import Categeory_2 from '../../../assets/images/home_page_3/category/02.png'
import Categeory_3 from '../../../assets/images/home_page_3/category/03.png'
import Categeory_4 from '../../../assets/images/home_page_3/category/04.png'
import Categeory_5 from '../../../assets/images/home_page_3/category/05.png'

const catageory = {
    slidesToShow: 5,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 2000,
    Infinity: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Catageory = () => {
    return (
        <>
            <section id="categories-three" className="categories-three-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section">
                                <div className="section-sub-title">Latest Category</div>
                                <h4 className="section-title-three">Our Categories</h4>
                            </div>
                        </div>
                    </div>
                    <Slider className="slider categories-three-autoplay" {...catageory}>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Men’s Shirt
                                    </Link>
                                </h5>
                                <p>118 items</p>
                            </div>
                        </div>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Smart Watch
                                    </Link>
                                </h5>
                                <p>40 items</p>
                            </div>
                        </div>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Men’s T-Shirt
                                    </Link>
                                </h5>
                                <p>118 items</p>
                            </div>
                        </div>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Men’s Shoes
                                    </Link>
                                </h5>
                                <p>78 items</p>
                            </div>
                        </div>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_5}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Men Perfumes
                                    </Link>
                                </h5>
                                <p>80 items</p>
                            </div>
                        </div>
                        <div className="categories-three-block">
                            <div className="categories-three-img">
                                <Link to="#" title="">
                                    <img
                                        src={Categeory_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </Link>
                                <div className="categories-three-line-block">
                                    <div className="categories-three-line-one" />
                                    <div className="categories-three-line-two" />
                                </div>
                            </div>
                            <div className="categories-three-dtls text-center">
                                <h5 className="categories-three-title jakarta-font">
                                    <Link to="#" title="">
                                        Men’s Shirt
                                    </Link>
                                </h5>
                                <p>118 items</p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

        </>
    )
}

export default Catageory
